import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	modalHeading: {
		id: 'jpd-project-directory-onboarding-modal.modal.heading',
		defaultMessage: 'Welcome to Jira Product Discovery',
		description: 'Heading for the Jira Product Discovery onboarding modal',
	},
	modalDescription: {
		id: 'jpd-project-directory-onboarding-modal.modal.description',
		defaultMessage: 'Here’s a few things you can use it for:',
		description: 'Description text introducing the list of onboarding features',
	},
	captureIdeas: {
		id: 'jpd-project-directory-onboarding-modal.capture-ideas',
		defaultMessage: 'Easily capture ideas and insights in one place',
		description: 'Feature: capturing ideas and insights',
	},
	logIdeas: {
		id: 'jpd-project-directory-onboarding-modal.log-ideas',
		defaultMessage: 'Log ideas and use insights to prioritize them',
		description: 'Feature: capturing ideas and insights',
	},
	prioritizeWithData: {
		id: 'jpd-project-directory-onboarding-modal.prioritize-with-data',
		defaultMessage: 'Use data and insights to prioritize them',
		description: 'Feature: using data and insights to prioritize ideas',
	},
	shareRoadmaps: {
		id: 'jpd-project-directory-onboarding-modal.share-roadmaps',
		defaultMessage: 'Share custom roadmaps with anyone',
		description: 'Feature: sharing custom roadmaps',
	},
	connectToJira: {
		id: 'jpd-project-directory-onboarding-modal.connect-to-jira',
		defaultMessage: 'Easily connect ideas into Jira for delivery',
		description: 'Feature: connecting ideas into Jira for delivery',
	},
	close: {
		id: 'jpd-project-directory-onboarding-modal.close',
		defaultMessage: 'Close',
		description: 'Button text to close the onboarding modal',
	},
	getStarted: {
		id: 'jpd-project-directory-onboarding-modal.get-started',
		defaultMessage: 'Get started',
		description: 'Button text to begin using the product',
	},
	trialInfo: {
		id: 'jpd-project-directory-onboarding-modal.trial-info',
		defaultMessage:
			'Free 30-day Premium plan trial. Cancel or downgrade anytime. By selecting “Get started” you agree to the <tc>Atlassian Customer Agreement</tc> and <pp>Privacy Policy</pp>.',
		description: 'Information about the free 30-day Premium plan trial and agreement terms',
	},
	modalSubHeading: {
		id: 'jpd-project-directory-onboarding-modal.modal.sub-heading',
		defaultMessage: 'Here’s a few things you can use it for:',
		description: 'Sub-heading for the Jira Product Discovery onboarding modal',
	},
	ariaLabel: {
		id: 'jpd-project-directory-onboarding-modal.aria-label',
		defaultMessage: 'Jira Product Discovery onboarding modal',
		description: 'Aria label for the onboarding modal',
	},
	projectTitleProductRoadmap: {
		id: 'jpd-project-directory-onboarding-modal.project-title.product-roadmap',
		defaultMessage: 'Product roadmap',
		description: 'Product roadmap project title of JPD',
	},
	projectTitlePrioritization: {
		id: 'jpd-project-directory-onboarding-modal.project-title.prioritization',
		defaultMessage: 'Prioritization',
		description: 'Prioritization project title of JPD',
	},
});
